import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "./button";

interface SentryFallbackProps {
  error: unknown;
  resetError: () => void;
}

export function SentryFallback({ resetError }: SentryFallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center">
      <div className="mb-4 rounded-full bg-destructive/10 p-3">
        <AlertCircle className="h-6 w-6 text-destructive" />
      </div>
      <h3 className="text-lg font-medium text-foreground">오류 발생</h3>
      <p className="mt-1 text-sm text-muted-foreground max-w-sm">
        예기치 못한 문제가 발생했습니다.
      </p>
      <Button variant="outline" onClick={resetError} className="mt-4">
        <RefreshCw className="h-4 w-4 mr-2" />
        다시 시도
      </Button>
    </div>
  );
}
